<template>
  <CRow sm="12">
    <CCol>
      <CCard>
        <CAlert v-if="alertMsg" :color="alertClr" fade>
          {{ alertMsg }}
        </CAlert>
        <CCol style="margin-top: 8px">
          <CButton color="info" @click="showModal" class="mr-1">
            新規作成
          </CButton>
        </CCol>
        <CCardBody>
          <nobr>
            <CDataTable
              hover
              striped
              clickable-rows
              :items="items"
              :fields="fields"
              :tableFilter="true"
              :sorter="true"
              :itemsPerPageSelect="true"
              :active-page="activePage"
              @row-clicked="rowClicked"
              :pagination="{ doubleArrows: false, align: 'center' }"
              @page-change="pageChange"
            >
              <template #No="{ index }">
                <td>
                  {{ index + 1 }}
                </td>
              </template>
              <template #experience_term="{ item }">
                <td v-if="item.experience_term">
                  {{ item.experience_term }} ヵ月
                </td>
                <td v-else>-</td>
              </template>
            </CDataTable>
          </nobr>
        </CCardBody>
        <SkillInfoAddModal
          :visible="addModalVisible"
          :selectedSkills="userSkillId"
          @close="closeAddModal($event)"
        />
        <SkillInfoEditModal
          :visible="editModalVisible"
          :data="inputItems"
          :index="index"
          :hasSkillInfoEditAuthorityProp="hasSkillInfoEditAuthority"
          @close="closeEditModal($event)"
          @showMessage="showMessageModal($event)"
        />
        <SkillInfoMessageModal
          :visible="messageModalVisible"
          @close="closeMessageModal($event)"
          :message="message"
        />
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import SkillInfoAddModal from "./SkillInfoAddModal";
import SkillInfoEditModal from "./SkillInfoEditModal";
import authorityControl from "../../mixins/authorityControl";
import constPage from "../../../definition/const/const_page";
import constOperationAuthority from "../../../definition/const/const_operation_authority";
import SkillInfoMessageModal from "./SkillInfoMessageModal";

export default {
  name: "SkillInfoList",
  mixins: [authorityControl],
  data() {
    return {
      items: [],
      fields: [
        { key: "No", label: "No." },
        { key: "fullname", label: "氏名" },
        { key: "abbreviation", label: "所属組織" },
        { key: "skill_fullname", label: "スキル名称" },
        { key: "category_name", label: "カテゴリ名称" },
        { key: "subcategory_name", label: "サブカテゴリ名称" },
        { key: "experience_term", label: "実務経験期間" },
      ],
      activePage: 1,
      alertMsg: "",
      alertClr: "",
      addModalVisible: false,
      editModalVisible: false,
      messageModalVisible: false,
      inputItems: {},
      index: 0,
      hasSkillInfoEditAuthority: false,
      message: "",
      filterSkillData:[],
      userSkillId:null,
    };
  },
  components: {
    SkillInfoAddModal,
    SkillInfoEditModal,
    SkillInfoMessageModal,
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    rowClicked(item, index) {
      // クリックされた行のデータを更新モーダルに渡す
      this.inputItems = { ...item };
      this.index = index + 1;
      this.editModalVisible = true;
      this.hasSkillInfoEditAuthority = this.hasEditAuthority(
        this.getAuthorityId(constPage.SKILLINFO_EDIT),
        this.inputItems.organization_id,
        this.inputItems.position_number
      );
      // メッセージを非表示
      this.alertMsg = "";
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    showModal() {
      this.getFilterSkillData();
      this.addModalVisible = true;
      // メッセージを非表示
      this.alertMsg = "";
    },
    showMessageModal(message) {
      this.message = message;
      this.messageModalVisible = true;
    },
    closeAddModal(result) {
      this.addModalVisible = false;
      // 表示アラート設定
      this.setAlert(result);
      //一覧更新
      this.fetchData();
    },
    closeEditModal(result) {
      this.editModalVisible = false;
      // 表示アラート設定
      this.setAlert(result);
      //一覧更新
      this.fetchData();
    },
    closeMessageModal() {
      this.messageModalVisible = false;
      this.message = "";
    },
    setAlert(altObj) {
      if (altObj) {
        this.alertClr = altObj.alertClr;
        this.alertMsg = altObj.alertMsg;
        // 画面上部までスクロールする
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
    getAccessControlledData(data) {
      let self = [
        constOperationAuthority.VIEW_SELF,
        constOperationAuthority.EDIT_SELF,
      ];
      let subordinate = [
        constOperationAuthority.VIEW_SUBORDINATE,
        constOperationAuthority.EDIT_SUBORDINATE,
      ];
      let all = [
        constOperationAuthority.VIEW_ALL,
        constOperationAuthority.EDIT_ALL,
      ];
      // 権限による絞り込み制御
      if (self.includes(this.authorityId)) {
        //「自分」で絞り込む
        return data.filter(
          (item) => item.user_id === this.$store.state.loginUser.user_id
        );
      } else if (subordinate.includes(this.authorityId)) {
        // 「自分の所属（配下含む）かつ役職が下のユーザー」＋「自分」で絞り込む
        return data.filter(
          (item) =>
            this.isSubordinate(item.organization_id, item.position_number) ||
            item.user_id === this.$store.state.loginUser.user_id
        );
      } else if (all.includes(this.authorityId)) {
        // 全ユーザー表示
        return data;
      }
    },
    async fetchData() {
      // 全ユーザーのスキル情報取得
      var allUserSkillData = await this.getUserSkillData();
      // スキル情報の表示権限制御
      this.items = this.getAccessControlledData(allUserSkillData);
    },
    async getUserSkillData() {
      let ret = null;
      await this.$axios
        .get("/api/v1/userskills")
        .then((res) => {
          ret = res.data.userskills;
        })
        .catch((e) => {
          console.error(e.response.data.message);
        });
      return ret;
    },
    //新規追加時のスキルフィルタ情報を作成
    async getFilterSkillData(){
      let self = [
        constOperationAuthority.VIEW_SELF,
        constOperationAuthority.EDIT_SELF,
      ];
      //自分以外のリストが表示されている際、自分の情報だけを取得するようにフィルタ
      if (!self.includes(this.authorityId)) {
        //「自分」で絞り込む
        this.filterSkillData = this.items.filter(
          (item) => item.user_id === this.$store.state.loginUser.user_id
          );
        // skillidだけを配列として取得
        this.userSkillId = this.filterSkillData.map(obj => obj.skill_id);  
      }else{
        // skillidだけを配列として取得
        this.userSkillId = this.items.map(obj => obj.skill_id);
      }
    },
  },
};
</script>

<style scoped>
.srchbar {
  display: inline-block;
  border-radius: 25px;
  border: 1px solid;
  border-color: silver;
  margin-right: 10px;
  height: 40px;
  width: 200px;
}
</style>